import type { FC, ReactNode } from 'react';
import { useSelector } from 'react-redux';

import { dealerSelectors } from '@makemydeal/dr-shared-store';

import { DealAssistantPanelLayout } from './DealAssistantPanelLayout';

export const DealAssistantLayout: FC<{ children: ReactNode }> = ({ children }) => {
    const isEnabled = useSelector(dealerSelectors.isDealAssistantEnabled);

    return isEnabled ? <DealAssistantPanelLayout>{children}</DealAssistantPanelLayout> : <>{children}</>;
};
